<template>
  <v-card class="mx-auto">
    <v-card-title>{{ $t("products.packages.packForm.title") }}</v-card-title>
    <v-card-text>
      <v-card outlined class="pa-4 mb-6">
        <v-row>
          <v-col md="8" sm="12">
            <v-row>
              <v-col>
                <v-text-field :label="`${$t('products.packages.packForm.packName')} *`"
                  v-model="form.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-tiptap v-model="form.description" :label="`${$t('products.packages.packForm.description')} *`"
                  :toolbar="toolbar" :injectCSS="true">
                  <template #calendar="{ editor }">
                    <v-btn icon small title="Calendar Icon" @click="changeContent(editor, 'calendar')">
                      <v-icon>mdi-calendar-outline</v-icon>
                    </v-btn>
                  </template>
                  <template #timer="{ editor }">
                    <v-btn icon small title="Timer icon" @click="changeContent(editor, 'timer')">
                      <v-icon>mdi-timer-outline</v-icon>
                    </v-btn>
                  </template>
                  <template #groupicon="{ editor }">
                    <v-btn icon small title="Group icon" @click="changeContent(editor, 'group')">
                      <v-icon>mdi-account-group-outline</v-icon>
                    </v-btn>
                  </template>
                </v-tiptap>

              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12" sm="12">

                <v-tiptap v-model="form.advantages" :label="$t('products.packages.packForm.advantages')"
                  :toolbar="toolbar" :injectCSS="true">
                  <template #calendar="{ editor }">
                    <v-btn icon small title="Calendar Icon" @click="changeContent(editor, 'calendar')">
                      <v-icon>mdi-calendar-outline</v-icon>
                    </v-btn>
                  </template>
                  <template #timer="{ editor }">
                    <v-btn icon small title="Timer icon" @click="changeContent(editor, 'timer')">
                      <v-icon>mdi-timer-outline</v-icon>
                    </v-btn>
                  </template>
                  <template #groupicon="{ editor }">
                    <v-btn icon small title="Group icon" @click="changeContent(editor, 'group')">
                      <v-icon>mdi-account-group-outline</v-icon>
                    </v-btn>
                  </template>
                </v-tiptap>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                    <div>
              <label class="pb-2 primary--text">
                {{ $t('products.packages.packForm.metrics')}}
              </label>
              <div>
                <!-- <div>
                  <v-card outlined class="pa-2 mb-1">
                    <div class="d-flex">
                      <div style="flex: 1 1 100%">
                        <v-text-field class="mb-1" hide-details dense label="CPM" v-model="form.globalCPM"></v-text-field>
                      </div>
                    </div>
                  </v-card>
                </div> -->
                <div v-for="(metric, i) in metrics" :key="i">
                  <v-card outlined class="pa-2 mb-1">
                    <div class="d-flex">
                      <div style="flex: 1 1 100%">
                        <v-text-field class="my-5" hide-details dense :label="$t('products.packages.packForm.param')"
                          v-model="metric.name"></v-text-field>
                        <v-text-field class="my-5" hide-details dense :label="$t('products.packages.packForm.value')"
                          v-model="metric.value"></v-text-field>
                        <v-text-field hide-details dense :label="$t('products.packages.packForm.label')" v-model="metric.label"></v-text-field>
                      </div>
                      <div>
                        <v-avatar color="primary" size="20">
                          {{ i + 1 }}
                        </v-avatar>
                        <v-btn icon color="error" @click="removeItem('metrics', i)">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
              <v-btn text block @click="addItem('metrics', { value: '', label: '', name: '' })">{{ $t('products.packages.packForm.addMetric') }}</v-btn>
            </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="4" sm="12">
            <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.imgTitle")
    }} *</label> <br>
    <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.dimensionTitle")
    }}</label>
            <FireUpload mime="'image/*'" :path="'/packages/'" type="image" @change-url="form.image = $event"
              :snap="form.image">
            </FireUpload>
            <div class="pt-3"></div>
            <v-text-field :label="$t('products.packages.packForm.urlVideo')" v-model="form.urlVideo"></v-text-field>
        
          </v-col>
        </v-row>
      </v-card>



      <v-row class="pb-6">
        <v-col cols="12" md="5">
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div>
                    <small>
                      <div>&nbsp;</div>
                    </small>
                    <div>
                      <div class="text-h4" v-if="form.stores">{{ form.stores.length }}</div>
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold">
                    {{ $t("products.packages.packForm.activeStore") }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div>
                    <small>
                      <div>&nbsp;</div>
                    </small>
                    <div>
                      <div class="text-h4" v-if="form.asus">{{ form.asus.length }}</div>
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold">
                    {{ $t("products.packages.packForm.formats") }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div>
                    <small>
                      <div>&nbsp;</div>
                    </small>
                    <div>
                      <div class="text-h4">{{ form.insertions }}</div>
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold">
                    {{ $t("products.packages.packForm.inserts") }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="7" sm="12">
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div>
                    <small v-if="form.totalPrice != form.finalPrice">
                      <div class="grey--text">
                        <span class="text-decoration-line-through">{{
      $n(form.totalPrice, "currency")
    }}</span>
                        <!-- <v-chip color="success" small v-if="form.totalDiscount">-{{ $n(form.totalDiscount, 'currency') }}</v-chip> -->
                        <v-chip color="success" class="ml-2" small v-if="form.totalDiscount">{{ form.percentDiscount |
      percentDiscount }}% OFF</v-chip>
                      </div>
                    </small>
                    <div class="text-h4">
                      {{ $n(form.finalPrice, "currency") }}
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold d-flex justify-space-between">
                    <span>
                      {{ $t("products.packages.packForm.price") }}
                    </span>
                    <v-menu offset-y left :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" color="primary" class="mt-n3"><v-icon
                            color="primary">mdi-pencil-outline</v-icon></v-btn>
                      </template>
                      <v-card width="300">
                        <v-list>
                          <v-list-item>
                            <v-list-item-title class="px-3">
                              <v-switch v-model="discountTypePercent" :label="discountTypePercent
      ? $t('products.packages.packForm.discount')
      : $t(
        'products.packages.packForm.fixedDiscount'
      )
      "></v-switch>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title class="px-3">
                              <v-text-field append-icon="mdi-percent" v-if="discountTypePercent" :label="$t('products.packages.packForm.labelDiscount')
      " type="number" min="0" max="100" v-model="form.percentDiscount"></v-text-field>
                              <v-text-field v-if="!discountTypePercent" label="Total de Descuento" min="0"
                                :max="form.totalPrice" v-model="form.totalDiscount"></v-text-field>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div>
                    <small>
                      <div>&nbsp;</div>
                    </small>
                    <div>
                      <div class="text-h4">{{ $n(form.impacts) }}</div>
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold">Impactos</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div>
                    <small>
                      <div>&nbsp;</div>
                    </small>
                    <div class="text-h4">{{ $n(form.cpm, "currency") }}</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold">
                    {{ $t("products.packages.packForm.cpm") }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-card :outlined="showAsus ? false : true" class="pa-4 mb-6">
        <v-card-title @click="showAsus = !showAsus" class="px-0 py-2">
          {{ $t("products.packages.packForm.showAsus") }}<v-spacer></v-spacer>
          <v-btn icon>
            <v-icon v-if="showAsus">mdi-chevron-down</v-icon>
            <v-icon v-if="!showAsus">mdi-chevron-up</v-icon>
          </v-btn>
        </v-card-title>
        <v-expand-transition>
          <v-card elevation="0" v-show="showAsus" v-if="!blockLoad">
            <div class="text-p pb-6 grey--text">
              {{ $t("products.packages.packForm.asusSubtitle") }} *
            </div>
            <AsusList @has-error="hasAsusError = $event" :is-dynamic="form.placementRule == 'dynamic'"
              :selectedOrdenate="true" :sortDesc="[true]" :range-start="form.rangeStart" :range-end="form.rangeEnd"
              type="selectToPackage" v-if="show" :rule="form.placementRule" :total-days="form.placementRule == 'dynamic' || form.placementRule == 'close'
      ? form.placementRulePeriods
        ? placementRulePeriods
        : 0
      : 0
      " :snap="form ? form.asus : null" @change-asus="updateConfig($event)"></AsusList>
          </v-card>
        </v-expand-transition>
      </v-card>
      <v-card outlined class="pa-4 mb-6">
        <v-row>
          <v-col>
            <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.computedInterest")
    }}</label>
            <div>
              <v-chip v-if="form.interests && !form.interests.length" color="yellow" class="mt-1">{{
      $t("products.packages.packForm.yesComputed") }}</v-chip>
              <v-chip v-for="(item, i) in form.interests" :key="i" class="mr-1 mt-1">{{ item }}</v-chip>
            </div>
          </v-col>
          <v-col>
            <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.placesInterest")
    }}</label>
            <div v-if="form.locations">
              <v-chip v-if="!form.locations.length" color="yellow">{{
      $t("products.packages.packForm.yesInterest")
    }}</v-chip>
              <v-chip v-for="(item, i) in form.locations" :key="i" class="mr-1 mt-1">{{ item.city }} - {{ item.state
                }}</v-chip>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="pa-4 mb-6" outlined>
        <v-row v-if="!placementLoading">
          <v-col>
            <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.planFillRules")
    }}</label>
            <v-select :items="placementRules" v-model="form.placementRule" item-value="value"
              item-text="text"></v-select>
            <v-alert type="info" outlined v-if="form.placementRule == 'free'">
              {{ $t("products.packages.packForm.freeInfo") }}
            </v-alert>
            <v-alert type="info" outlined v-if="form.placementRule == 'dynamic'">
              {{ $t("products.packages.packForm.dynamicInfo") }}
            </v-alert>
            <v-alert type="info" outlined v-if="form.placementRule == 'close'">
              {{ $t("products.packages.packForm.closeInfo") }}
            </v-alert>
          </v-col>
          <v-col>
            <template v-if="form.placementRule == 'dynamic'">
              <label class="pb-2 primary--text">{{ $t('products.packages.packForm.fillFirstDate') }}</label>
              <v-text-field @input="v$.form.placementRulePeriods.$touch()" @blur="v$.form.placementRulePeriods.$touch()"
                :errorMessages="periodRangeErrors" type="number" step="1" min="1"
                v-model="form.placementRulePeriods"></v-text-field>
            </template>
          </v-col>
        </v-row>
        <v-divider class="mb-6"></v-divider>
        <v-row>
          <v-col>
            <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.packPlace")
    }}</label>
            <v-switch v-model="form.hasLimitPlacement" :disabled="form.placementRule == 'close'" :label="form.hasLimitPlacement
      ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')
      "></v-switch>
            <div class="d-flex" v-if="form.hasLimitPlacement">
              <div class="mr-2">
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="`${$t('products.packages.packForm.limitInitDate')} ${form.hasLimitPlacement ? '*' : ''}`"
                      readonly v-model="formatedDateRangeStart" v-bind="attrs" v-on="on"
                      append-icon="mdi-calendar"></v-text-field>
                  </template>
                  <v-date-picker v-model="form.rangeStart" :allowed-dates="allowedRangeStart"></v-date-picker>
                </v-menu>
              </div>
              <div>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="`${$t('products.packages.packForm.limitEndDate')} ${form.hasLimitPlacement ? '*' : ''}`"
                      readonly v-model="formatedDateRangeEnd" v-bind="attrs" v-on="on"
                      append-icon="mdi-calendar"></v-text-field>
                  </template>
                  <v-date-picker v-model="form.rangeEnd" :allowed-dates="allowedRangeEnd"></v-date-picker>
                </v-menu>
              </div>
            </div>
          </v-col>
          <v-col>
            <label class="pb-2 primary--text">{{ $t(`products.packages.packForm.hasLimitUse`) }}</label>
            <v-switch v-model="hasLimitUse" :label="hasLimitUse ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')"></v-switch>

            <div v-if="hasLimitUse && form.limits">
              <v-text-field v-model="form.limits.quantity"
                :label="$t(`products.packages.packForm.limit`)"></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <v-text-field type="number"
              :label="$t(`products.packages.packForm.reservationMin`)"
              v-model="form.reservationMin" min="3" step="1" max="30" @input="v$.form.reservationMin.$touch()"
              @blur="v$.form.reservationMin.$touch()" :errorMessages="reservationMinErrors">
            </v-text-field>

          </v-col>

        </v-row>
      </v-card>

      <v-card outlined class="pa-4 mb-6">
        <v-row>
          <v-col>
            <label class="pb-2 primary--text">{{
      $t("products.packages.packForm.packDate")
    }}</label>
            <v-switch v-model="form.hasValidate" :label="form.hasValidate
      ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')
      "></v-switch>
            <div class="d-flex" v-if="form.hasValidate">
              <div class="mr-2">
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :label="$t('products.packages.packForm.initialDate')" readonly
                      v-model="formatedDateStart" v-bind="attrs" v-on="on" append-icon="mdi-calendar"></v-text-field>
                  </template>
                  <v-date-picker v-model="form.startDate" :allowed-dates="allowedStart"></v-date-picker>
                </v-menu>
              </div>
              <div>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :label="$t('products.packages.packForm.endDate')" readonly v-model="formatedDateEnd"
                      v-bind="attrs" v-on="on" append-icon="mdi-calendar"></v-text-field>
                  </template>
                  <v-date-picker v-model="form.dueDate" :allowed-dates="allowedEnd"></v-date-picker>
                </v-menu>
              </div>
            </div>
          </v-col>
          <!-- <v-col>
            <label class="pb-2 primary--text" v-html="$t('mainStore.packageNeedQuotation.subtitle')"></label>
            <v-switch v-model="form.needQuotation" :label="form.needQuotation
      ? $t('mainStore.packageNeedQuotation.allow')
      : $t('mainStore.packageNeedQuotation.disallow')
      "></v-switch>
          </v-col> -->
        </v-row>
        <v-divider class="my-6"></v-divider>
        <v-row>

          <v-col>
            <label class="pb-2 primary--text" v-html="$t('products.packages.inHomeLegend')"></label>
            <v-switch v-model="form.inHome" :label="form.inHome
      ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')
      "></v-switch>
          </v-col>
          <v-col>
            <label class="pb-2 primary--text" v-html="$t('products.packages.featuredLegend')"></label>
            <v-switch v-model="form.featured" :disabled="!form.inHome" :label="form.featured
      ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')
      "></v-switch>
          </v-col>
        </v-row>

        <v-divider class="my-6"></v-divider>
        <v-row>

          <v-col>
            <label class="pb-2 primary--text" v-html="$t('products.packages.packForm.formatCount')"></label>
            <v-switch v-model="form.config.formats" :label="form.config.formats
      ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')
      "></v-switch>
          </v-col>
          <v-col>
            <label class="pb-2 primary--text" v-html="$t('products.packages.packForm.showCountStores')"></label>
            <v-switch v-model="form.config.broadcasts" :label="form.config.broadcasts
      ? $t('products.packages.packForm.yes')
      : $t('products.packages.packForm.no')
      "></v-switch>
          </v-col>
        </v-row>
        <template
          v-if="masterStore.integrations && masterStore.integrations.googleAdManager && masterStore.integrations.googleAdManager.enabled">

          <v-divider class="my-6"></v-divider>
          <v-row v-if="adManagerEnabled"><v-col>{{ $t('products.packages.packForm.adManagerOptions') }}</v-col></v-row>
          <v-row v-if="!loadingOption && adManagerEnabled">
            <v-col>
              <v-text-field v-if="form.options && form.options.title" v-model="form.options.title"
                label="Titulo"></v-text-field>
              <v-text-field v-if="form.options && form.options.legend" v-model="form.options.legend"
                label="Legenda"></v-text-field>
              <template v-if="form.options && form.options.lists">
                <v-card outlined class="pa-2" v-for="(option, index) in form.options.lists" :key=index>
                  <v-card outlined class="pa-2 mb-2">
                    <div class="d-flex">
                      <v-text-field v-model="option.name" label="Nombre"></v-text-field>
                      <v-card style="width: 50%; flex: 0 0 50%"  outlined class="pa-2 mr-1">
                      <div class="ml-1 d-flex py-2 align-center" v-for="(valueOption, i) in option.values" :key="`${index}-${i}`">
                        <v-text-field dense hide-details v-model="valueOption.id" label="AdUnit"></v-text-field>
                        <v-btn class="ml-1" small color="red" icon @click="removeListItem(index, i)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>

                      </div>
                      <v-btn text @click="addListItem(index)" block>{{ $t('products.packages.packForm.addUnit') }}</v-btn>
                    </v-card>
                    </div>
                    <v-btn small color="red" icon @click="removeOption(index)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                  </v-card>
                </v-card>
              </template>
              <v-btn text @click="addOption()" block>{{ $t('products.packages.packForm.addOption') }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select label="Tipo de contenido" v-model="form.gamCreativeType" :items="['image', 'video']"></v-select>
            </v-col>
            <v-col>
              <div v-if="form.gamCreativeType">
                <div v-for="(item, i) in gamCreativeTypes" :key="i" class="d-flex">
                  <v-select label="Tipo de archivo" v-model="gamCreativeTypes[i]" item-text="name" item-value="value" :items="mimeTypes[form.gamCreativeType]"></v-select>
                  <v-btn small color="red" icon @click="removeItem('gamCreativeTypes', i)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                </div>
                <v-btn text block @click="addItem('gamCreativeTypes', {name: '', mime: ''})">{{ $t('products.packages.packForm.addContentType') }}</v-btn>
              </div>
            </v-col>
            <v-col>
              <div>
                <label class="pb-2 primary--text">
                  {{ $t('products.packages.packForm.creativePlaceholders') }}
                </label>
                <div>
                  <div v-for="(item, i) in gamCreativePlaceholders" :key="i">
                    <v-card outlined class="pa-2 mb-1">
                      <div class="d-flex">
                        <div style="flex: 1 1 100%" class=d-flex>
                          <v-text-field v-if="form.gamCreativeType && form.gamCreativeType == 'video'" class="mb-1 mr-1" hide-details dense :label="$t('products.packages.packForm.duration')"
                            v-model="item.duration"></v-text-field>
                            <v-text-field v-if="form.gamCreativeType && form.gamCreativeType == 'video'" class="mb-1 mr-1" hide-details dense :label="$t('products.packages.packForm.size')"
                            v-model="item.length"></v-text-field>
                            <v-divider vertical class="mx-1" v-if="form.gamCreativeType && form.gamCreativeType == 'video'"></v-divider><v-text-field class="mb-1 mr-1" hide-details dense :label="$t('products.packages.packForm.width')"
                            v-model="item.size.width"></v-text-field>
                          <v-text-field class="mb-1" hide-details dense :label="$t('products.packages.packForm.height')"
                            v-model="item.size.height"></v-text-field>
                        </div>
                        <div>
                          <v-avatar color="primary" size="20">
                            {{ i + 1 }}
                          </v-avatar>
                          <v-btn icon color="error" @click="removeItem('gamCreativePlaceholders', i)">
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
                <v-btn text block @click="addItem('gamCreativePlaceholders', { length: 0, duration: 0, size: { width: '', width: '' } })">{{ $t('products.packages.packForm.addPlaceholder')}}
                  </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
        <v-divider class="my-6"></v-divider>
        <v-row>
          <v-col>
            <v-switch v-model="form.status" :label="form.status
      ? $t('products.packages.active')
      : $t('products.packages.inactive')
      "></v-switch>
          </v-col>
          <v-col>
            <label class="pb-2 primary--text" v-html="$t('products.packages.packForm.hideAsus.title')"></label>
            <v-switch v-model="form.hideAsus" :label="form.hideAsus
      ? $t('products.packages.packForm.hideAsus.hidden')
      : $t('products.packages.packForm.hideAsus.notHidden')
      "></v-switch>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col class="d-flex">
          <v-btn icon color="error" :disabled="anyOrderWithThisPack" @click="removePack = true">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text large @click="$emit('show-form', false)">{{
      $t("products.packages.packForm.cancel")
    }}</v-btn>
          <v-btn color="success" :loading="processing" elevation="0" large :disabled="!isValidToSave || hasAsusError"
            @click="save()">{{
            $t("products.packages.packForm.save") }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="removePack" width="540">
      <v-card class="mx-auto">
        <v-card-title>
          <div class="d-flex">
            <span>Tem certeza que deseja remover este pacote permanentemente?</span>
            <!-- <v-btn @click="removePack = false" icon><v-icon>mdi-close</v-icon></v-btn> -->
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn @click="removePack = false" text>{{ $t('common.cancel') }}</v-btn>
            <v-btn @click="remove()" color="error" elevation="0">{{ $t('common.remove') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import moment from "moment";
import config from "@/store/config";
import FireUpload from "@/interface/FireUpload.vue";
import AsusList from "./AsusList.vue";
import { initializeApp } from "firebase/app";
import useVuelidate from "@vuelidate/core";
import { required, minValue, maxValue } from "vuelidate/lib/validators";

import { mapActions, mapState } from "vuex";

import axios from "axios";
import {
  getFirestore,
  collection,
  query,
  where,
  deleteDoc,
  getDocs,
  doc,
  setDoc,
} from "firebase/firestore";

export default {
  setup() {
    return { v$: useVuelidate() };
  },

  validations: {
    form: {
      placementRulePeriods: {
        required,
        minValue: minValue(3),
        maxValue: maxValue(10),
      },
      reservationMin: {
        required,
        minValue: minValue(3),
        maxValue: maxValue(30),
      }
    },
  },

  name: "PackageForm",
  components: { AsusList, FireUpload },
  data: () => ({
  mimeTypes: {
    video: [
      {name: 'MP4', value: {mime: 'video/mp4', name: 'MP4'}},
      {name: 'MOV', value: {mime: 'video/mov', name: 'MOV'}}
    ],
    image: [
      {name: 'JPG', value: {mime: 'image/jpeg', name: 'JPG'}},
      {name: 'GIF', value: {mime: 'image/gif', name: 'GIF'}},
      {name: 'PNG', value: {name: 'PNG', mime: 'image/png'}}
    ]
  },
    loadingOption: false,
    hasAsusError: false,
    hasLimitUse: false,
    toolbar: ["bold",
      "italic",
      "underline",
      "color",
      "|",
      "headings",
      "|",
      "left",
      "center",
      "right",
      "justify",
      "|",
      "bulletList",
      "orderedList",
      "|",
      "link",
      "emoji",
      "|",

      "#calendar",
      "#timer",
      "#groupicon",
      "|",
      "clear"],
    removePack: false,
    anyOrderWithThisPack: false,
    asuSelected: [],
    blockLoad: true,
    placementLoading: false,
    placementRules: [],
    processing: false,
    loading: false,
    saved: false,
    showAsus: true,
    discountTypePercent: true,
    metrics: [],
    gamCreativePlaceholders: [],
    gamAdUnits: [],
    gamCreativeTypes: [
      { name: 'JPG', mime: 'image/jpeg' }, { name: 'PNG', mime: 'image/png' }, { name: 'GIF', mime: 'image/gif' }
    ],

    form: {
      reservationMin: 3,
      computedAsus: {
        buckets: {},
        formats: {},
        mediaTypes: {},
      },
      config: {
        broadcasts: true,
        formats: true
      },
      limits: null,
      featured: false,
      inHome: true,
      hideAsus: false,
      needQuotation: false,
      createdOn: null,
      updatedOn: null,
      hasValidate: false,
      hasLimitPlacement: false,
      placementRule: "free",
      placementRulePeriods: null,
      asus: [],
      insertions: 0,
      cpm: null,
      description: "",
      discount: 0,
      startDate: null,
      dueDate: null,
      rangeStart: null,
      rangeEnd: null,
      totalPrice: 0,
      totalDiscount: 0,
      percentDiscount: 0,
      finalPrice: 0,
      id: null,
      image: null,
      urlVideo: null,
      advantages: null,
      impacts: 0,
      locations: [],
      name: "",
      placement: "",
      status: false,
      stores: [],
      interests: [],
      coverage: []
    },
    model: {
      reservationMin: 3,
      createdOn: null,
      updatedOn: null,
      hasValidate: false,
      hasLimitPlacement: false,
      placementRule: "free",
      placementRulePeriods: null,
      asus: [],
      insertions: 0,
      cpm: null,
      limits: null,
      description: "",
      discount: 0,
      startDate: null,
      dueDate: null,
      rangeStart: null,
      rangeEnd: null,
      totalPrice: 0,
      featured: false,
      inHome: true,
      totalDiscount: 0,
      percentDiscount: 0,
      finalPrice: 0,
      id: null,
      image: null,
      impacts: 0,
      locations: [],
      name: "",
      placement: "",
      status: false,
      stores: [],
      interests: [],
      coverage: []
    },

  }),
  props: {
    snap: [Object, null],
    show: Boolean,
  },
  computed: {
    ...mapState("groupStores", [
      "masterStore"]
    ),
    adManagerEnabled(){
      return this.masterStore.integrations && this.masterStore.integrations.googleAdManager && this.masterStore.integrations.googleAdManager.enabled
    },
    minPeriodaAsus() {
      //pega a lista de asus selecionadas e retorna o maior valor do periods.min

      const biggestMin = this.form.computedAsus.rules.reduce(
        (biggestMin, obj) => {
          if (obj.periods.min > biggestMin) {
            return obj.periods.min;
          }
          return biggestMin;
        },
        Number.NEGATIVE_INFINITY
      );

      return biggestMin;
    },

    maxPeriodaAsus() {
      const biggestMax = this.form.computedAsus.rules.reduce((biggestMax, obj) => {
        const maxPeriod = obj.periods.max;

        if (maxPeriod === null || maxPeriod === undefined) {
          return biggestMax;
        }

        if (biggestMax === null || maxPeriod > biggestMax) {
          return maxPeriod;
        }

        return biggestMax;
      }, null);

      return biggestMax;
    },


    periodRangeErrors() {
      const errors = [];
      if (!this.v$.form.placementRulePeriods.$dirty) return errors;
      this.v$.form.placementRulePeriods.minValue.$invalid &&
        errors.push(
          this.$t(`El valor mínimo permitido es de ${this.minPeriodaAsus} días`, {
            count: 3,
          })
        );
      this.v$.form.placementRulePeriods.maxValue.$invalid &&
        errors.push(
          this.$t(`El valor máximo permitido es de ${this.maxPeriodaAsus} días`, {
            count: 100,
          })
        );
      this.v$.form.placementRulePeriods.required.$invalid &&
        errors.push(this.$t("Este campo es obligatorio"));
      return errors;
    },
    reservationMinErrors() {
      const errors = [];
      if (!this.v$.form.reservationMin.$dirty) return errors;
      this.v$.form.reservationMin.minValue.$invalid &&
        errors.push(
          this.$t(`El valor mínimo permitido es de 3 días`, {
            count: 3,
          })
        );
      this.v$.form.reservationMin.maxValue.$invalid &&
        errors.push(
          this.$t(`El valor máximo permitido es de 30 días`, {
            count: 30,
          })
        );
      this.v$.form.reservationMin.required.$invalid &&
        errors.push(this.$t("Este campo es obligatorio"));
      return errors;
    },

    placementRulePeriods() {
      return this.form.placementRulePeriods
        ? parseInt(this.form.placementRulePeriods)
        : null;
    },
    isValidToSave() {
      return (

        this.form.name && this.form.name.length &&
        this.form.description &&
        this.form.asus && this.form.asus.length &&
        this.form.finalPrice &&
        this.form.image &&
        this.form.stores && this.form.stores.length &&
        (!this.form.hasValidate || this.form.dueDate) &&
        (!this.form.hasLimitPlacement ||
          this.form.rangeStart ||
          this.form.rangeEnd)
      );
    },
    formatedDateStart() {
      if (!this.form.startDate) return "-";
      return moment(this.form.startDate, "YYYY-MM-DD").format("LL");
    },
    formatedDateEnd() {
      if (!this.form.dueDate) return "-";
      return moment(this.form.dueDate, "YYYY-MM-DD").format("LL");
    },
    formatedDateRangeStart() {
      if (!this.form.rangeStart) return "-";
      return moment(this.form.rangeStart, "YYYY-MM-DD").format("LL");
    },
    formatedDateRangeEnd() {
      if (!this.form.rangeEnd) return "-";
      return moment(this.form.rangeEnd, "YYYY-MM-DD").format("LL");
    },
  },
  watch: {
    'hasLimitUse': {
      handler(v) {
        if (v) {
          if (!this.form.hasOwnProperty('limits')) {
            this.form.limits = {
              type: ''
            }
          }
          if (!this.form.limits) {
            this.form.limits = {
              type: 'simultaneity',
              quantity: 0,
              log: []
            }
          }
          else {
            this.form.limits.type = 'simultaneity'
          }
        }
        else {
          this.form.limits = {
            type: 'no-limit'
          }
        }
      }
    },
    "form.inHome": {
      handler(v) {
        if (!v) {
          this.form.featured = false
        }
      }
    },
    "form.placementRule": {
      deep: true,
      handler(val) {
        if (val == "close") {
          this.form.hasLimitPlacement = true;
        }
      },
    },
    "form.rangeStart": {
      deep: true,
      handler(val) {
        if (val && this.form.rangeEnd) {
          if (this.form.placementRule == "close")
            this.form.placementRulePeriods =
              moment(this.form.rangeEnd, "YYYY-MM-DD").diff(
                moment(val, "YYYY-MM-DD"),
                "days"
              ) + 1;
        } else {
          if (this.form.placementRule == "close")
            this.form.placementRulePeriods = 0;
        }
      },
    },
    "form.rangeEnd": {
      deep: true,
      handler(val) {
        if (val && this.form.rangeStart) {
          if (this.form.placementRule == "close")
            this.form.placementRulePeriods =
              moment(val, "YYYY-MM-DD").diff(
                moment(this.form.rangeStart, "YYYY-MM-DD"),
                "days"
              ) + 1;
        } else {
          if (this.form.placementRule == "close")
            this.form.placementRulePeriods = 0;
        }
      },
    },
    // 'form.placementRulePeriods'
    // 'form.placementRule':{
    //     deep: true,
    //     handler(value){
    //         console.log('value', value)
    //         console.log('reloading placement rule')
    //         this.placementLoading = true
    //         setTimeout(() => {
    //             this.placementLoading = false
    //         },500)
    //     }
    // },
    "form.percentDiscount"() {
      if (this.discountTypePercent) {
        this.calc();
      }
    },
    snap: {
      deep: true,
      handler(value) {
        const v = JSON.parse(JSON.stringify(value))
        if (v && Object.keys(v).length) {
          if (!v.hasOwnProperty("placementRule")) {
            v.placementRule = "free";
            v.placementRulePeriods = 0;
          }
          if (!v.hasOwnProperty("placementRulePeriods")) {
            v.placementRulePeriods = 0;
          }
          if (!v.hasOwnProperty("config")) {
            v.config = {
              broadcasts: true,
              formats: true
            }
          }
          if (!v.hasOwnProperty("metrics")) {
            this.metrics = []
            v.metrics = [];
          }
          else {
            this.metrics = v.metrics
          }
          if (!v.hasOwnProperty("globalCPM")) {
            this.globalCPM = 0
            v.globalCPM = 0;
          }
          else {
            this.globalCPM = v.globalCPM
          }
          if (!v.hasOwnProperty("gamAdUnits")) {
            this.gamAdUnits = []
            v.gamAdUnits = [];
          }
          else {
            v.gamAdUnits.forEach((item) => {
              this.gamAdUnits.push({ id: item })
            })
          }
          if (!v.hasOwnProperty("gamCreativePlaceholders")) {
            this.gamCreativePlaceholders = []
            v.gamCreativePlaceholders = [];
          }
          else {
            this.gamCreativePlaceholders = v.gamCreativePlaceholders
          }
          if (!v.hasOwnProperty("gamCreativeTypes")) {
            this.gamCreativeTypes = [
              { name: 'JPG', mime: 'image/jpeg' }, { name: 'PNG', mime: 'image/png' }, { name: 'GIF', mime: 'image/gif' }
            ]
            v.gamCreativeTypes = [
              { name: 'JPG', mime: 'image/jpeg' }, { name: 'PNG', mime: 'image/png' }, { name: 'GIF', mime: 'image/gif' }
            ];
          }
          else {
            this.gamCreativeTypes = v.gamCreativeTypes
          }
          if (!v.hasOwnProperty("inHome")) {
            v.inHome = true;
          }
          if (!v.hasOwnProperty("featured")) {
            v.featured = 0;
          }
          if (!v.hasOwnProperty("limits")) {
            v.limits = null;
          }
          else {
            if (v.limits && v.limits.hasOwnProperty('type') && v.limits.type == 'simultaneity') {
              this.hasLimitUse = true
            }
          }
          if (!v.hasOwnProperty('reservationMin')) {
            v.reservationMin = 3
          }
          this.form = v;
          this.loadOrders()
        } else {
          this.loadOrders()
          this.form = JSON.parse(JSON.stringify(this.model));
        }
      },
    },
    "form.totalDiscount"() {
      if (!this.discountTypePercent) {
        this.calc();
      }
    },
    // 'form.hasValidate'(val){
    //         this.form.hasLimitPlacement = val
    // },
    // 'form.hasLimitPlacement'(val){
    //     if(val){
    //         this.form.hasValidate = val
    //     }
    // }
  },
  mounted() {
    this.placementRules = [
      {
        text: this.$t("products.packages.packForm.placementRules.free"),
        value: "free",
      },
      {
        text: this.$t("products.packages.packForm.placementRules.dynamic"),
        value: "dynamic",
      },
      {
        text: this.$t("products.packages.packForm.placementRules.close"),
        value: "close",
      },
    ];

    if (this.snap) {
      const v = JSON.parse(JSON.stringify(this.snap));
      if (v && Object.keys(v).length) {
        this.form = v;
      } else {
        this.form = JSON.parse(JSON.stringify(this.model));
        this.blockLoad = false;
      }
      if (this.form.status == "published") {
        this.form.status = true;
      } else {
        this.form.status = false;
      }
      if (!v.hasOwnProperty("config")) {
        v.config = {
          broadcasts: true,
          formats: true
        }
      }
      if (!v.hasOwnProperty("metrics")) {
        this.metrics = []
        v.metrics = [];
      }
      else {
        this.metrics = v.metrics
      }
      if (!v.hasOwnProperty("gamAdUnits")) {
        this.gamAdUnits = []
        v.gamAdUnits = [];
      }
      else {
        v.gamAdUnits.forEach((item) => {
          this.gamAdUnits.push({ id: item })
        })
      }
      if (!v.hasOwnProperty("gamCreativePlaceholders")) {
        this.gamCreativePlaceholders = []
        v.gamCreativePlaceholders = [];
      }
      else {
        this.gamCreativePlaceholders = v.gamCreativePlaceholders
      }
      if (!v.hasOwnProperty("gamCreativeTypes")) {
        this.gamCreativeTypes = [
          { name: 'JPG', mime: 'image/jpeg' }, { name: 'PNG', mime: 'image/png' }, { name: 'GIF', mime: 'image/gif' }
        ]
        v.gamCreativeTypes = [
          { name: 'JPG', mime: 'image/jpeg' }, { name: 'PNG', mime: 'image/png' }, { name: 'GIF', mime: 'image/gif' }
        ]
      }
      else {
        this.gamCreativeTypes = v.gamCreativeTypes
      }

      if (!v.hasOwnProperty("limits")) {
        v.limits = null;
      }
      else {
        if (v.limits && v.limits.hasOwnProperty('type') && v.limits.type == 'simultaneity') {
          this.hasLimitUse = true
        }
      }

      if (!this.form.hasOwnProperty("placementRule")) {
        this.form.placementRule = "free";
        this.form.placementRulePeriods = 0;
      }

      this.form.asus = v.asus;
    }
    this.loadOrders()
    setTimeout(() => {
      this.blockLoad = false;
    }, 100);
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    addItem(field, obj) {
      this[field].push(obj)
    },
    addOption() {
      this.loadingOption = true
      if (!this.form.hasOwnProperty('options') || !this.form.options.title) {
        this.form.options = {
          legend: 'Legenda...',
          title: 'Titulo',
          multiple: true,
          required: true,
          lists: [{ name: '', values: [] }]
        }
      }
      else {
        this.form.options.lists.push({ name: '', values: [] })
      }
      setTimeout(() => {
        this.loadingOption = false
      }, 100)
    },
    addListItem(index) {
      this.loadingOption = true
      this.form.options.lists[index].values.push({ id: '' })
      setTimeout(() => {
        this.loadingOption = false
      }, 100)
    },
    removeOption(index) {
      this.loadingOption = true

      this.form.options.lists.splice(index, 1)
      setTimeout(() => {
        this.loadingOption = false
      }, 100)
    },
    removeListItem(index, i) {
      this.loadingOption = true
      this.form.options.lists[index].splice(i, 1)
      setTimeout(() => {
        this.loadingOption = false
      }, 100)
    },
    removeItem(field, i) {
      this[field].splice(i, 1)
    },
    remove() {
      const firebase = initializeApp(config)
      const db = getFirestore(firebase);
      deleteDoc(doc(db, "packages", this.form.id)).then(() => {
        this.showSnack({
          text: this.$t("package.removed"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        this.$emit('reload-documents', true)
      })

    },
    changeContent(editor, icon) {

      editor.commands.insertContent(`#${icon}`)
      // let n = this.form.description
      // console.log('n', n)
      // this.form.description = n.split(`#${icon}#`).join(`<i aria-hidden="true" class="v-icon notranslate mdi ${icon} theme--light primary--text"></i>`)
    },
    loadOrders() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "orders"));
      const querySnapshot = getDocs(q);
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          const orderData = doc.data();
          orderData.simulation.forEach((simulation) => {
            if (simulation.pack && simulation.pack.id == this.form.id) {
              this.anyOrderWithThisPack = true
              return true;
            }
          })
        })
      })
      this.anyOrderWithThisPack = false
    },
    allowedStart(val) {
      return moment(val).isAfter(moment());
    },
    allowedEnd(val) {
      return this.form.startDate
        ? moment(val).isAfter(moment(this.form.startDate))
        : moment(val).isAfter(moment());
    },
    allowedRangeStart(val) {
      return this.form.startDate
        ? moment(val).isAfter(moment(this.form.startDate))
        : moment(val).subtract(1, "day").isAfter(moment());
    },
    allowedRangeEnd(val) {
      return this.form.rangeStart
        ? moment(val).isAfter(moment(this.form.rangeStart))
        : this.form.hasValidate
          ? this.form.dueDate
            ? moment(val).isAfter(moment(this.form.dueDate))
            : moment(val).isAfter(moment())
          : moment(val).isAfter(moment());
    },

    updateConfig(e) {
      const asus = [];
      const config = {
        cpm: 0,
        reservationMin: 3,
        discount: 0,
        impacts: 0,
        totalImpacts: 0,
        totalPrice: 0,
        percentDiscount: 0,
        totalDiscount: 0,
        discountPercent: 0,
        finalPrice: 0,
        price: 0, 
        insertions: 0,
        stores: [],
        locations: {},
        interests: {},
        coverage: {},
        computedAsus: {
          buckets: {},
          allLocations: [],
          formats: {},
          mediaTypes: {},
          rules: [],
        },
      };
      const packageAsus = JSON.parse(JSON.stringify(e))
      packageAsus.forEach((asu, _aindex) => {
        console.log('AsuFormat', asu.format)
        // console.log("asu", asu);
        console.log('asu.computed', asu.computed)
        console.log('asu.computed.formatText', asu.computed.formatText)

        let formatRules = {
          periods: asu.rules.periods,
          insertions: asu.rules.insertions,
        };
        config.computedAsus.rules.push(formatRules);
        // console.log('rulesArr',config.computedAsus.rules)
        asu.buckets.forEach((bucket) => {
          config.computedAsus.buckets[`${bucket.title}-${bucket.name}`] =
            bucket;
        });
        config.computedAsus.buckets = Object.values(
          config.computedAsus.buckets
        );

        config.computedAsus.formats[`${asu.computed.formatText}`] = asu.format;
        config.computedAsus.allLocations.concat(asu.locations)

        config.computedAsus.mediaTypes[
          `${asu.mediaType.category}-${asu.mediaType.parents}`
        ] = asu.mediaType;
        config.computedAsus.mediaTypes = Object.values(
          config.computedAsus.mediaTypes
        );

        config.totalPrice +=
          parseFloat(asu.rules.pricing.unityPrice) * asu.insertions;
        config.totalImpacts += parseFloat(asu.audience.value) * asu.insertions;
        config.impacts += parseFloat(asu.audience.value);
        asus.push({
          sku: asu.id,
          insertions: parseFloat(asu.insertions),
          duration: asu.duration,
        });
        config.insertions += parseFloat(asu.insertions);
        if (!config.stores.includes(asu.store)) {
          config.stores.push(asu.store);
        }
        if(asu.mediaType.parents != 'midiaExterior'){
          asu.locations.forEach((loc) => {
            config.locations[`${loc.city} - ${loc.state} - ${loc.country}`] = loc;
          });
        }
        else{
          asu.locations.forEach((loc, iLoc) => {
            config.locations[`${loc.location.coordinates[0]}_${loc.location.coordinates[1]}`] = loc;
          });
        }
        

        asu.interests.forEach((interest) => {
          config.interests[interest] = interest;
        });
        if (!asu.hasOwnProperty('coverage'))
          asu.coverage = []
        asu.coverage.forEach((coverage) => {
          config.coverage[coverage] = coverage
        })
      });
      this.form.asus = asus;

      if (this.form.hasOwnProperty("computedAsus")) {
        this.form.computedAsus.rules = config.computedAsus.rules;
      } else {
        this.form.computedAsus = { rules: config.computedAsus.rules };
      }
      if (this.form.hasOwnProperty("computedAsus")) {
        this.form.computedAsus.buckets = config.computedAsus.buckets;
      } else {
        this.form.computedAsus = { buckets: config.computedAsus.buckets };
      }
      if (this.form.hasOwnProperty("computedAsus")) {
        this.form.computedAsus.formats = Object.values(
          config.computedAsus.formats
        );
      } else {
        this.form.computedAsus = { formats: Object.values(
          config.computedAsus.formats
        )};
      }

      if (this.form.hasOwnProperty("computedAsus")) {
        this.form.computedAsus.locations = config.locations;
      } else {
        this.form.computedAsus = { locations: config.locations };
      }


      if (this.form.hasOwnProperty("computedAsus")) {
        this.form.computedAsus.coverage = config.coverage;
      } else {
        this.form.computedAsus = { coverage: config.coverage };
      }

      if (this.form.hasOwnProperty("computedAsus")) {
        this.form.computedAsus.mediaTypes = config.computedAsus.mediaTypes;
      } else {
        this.form.mediaTypes = { mediaTypes: config.computedAsus.mediaTypes };
      }

      this.form.insertions = config.insertions;
      this.form.impacts = config.totalImpacts;
      this.form.totalPrice = config.totalPrice;
      this.form.stores = config.stores;
      this.form.interests = Object.keys(config.interests);
      this.form.coverage = Object.keys(config.coverage)
      this.form.locations = Object.values(config.locations);
      this.calc();
      // this.form.percentDiscount = (config.totalDiscount / config.totalPrice) * 100
    },

    calc() {
      let discount = this.discountTypePercent
        ? this.form.totalPrice * (this.form.percentDiscount / 100)
        : this.form.totalDiscount;
      if (this.discountTypePercent) {
        this.form.totalDiscount = discount;
      } else {
        this.form.percentDiscount =
          (this.form.totalDiscount / this.form.totalPrice) * 100;
      }
      if (!discount || !this.form.percentDiscount) {
        discount = 0
      }
      this.form.finalPrice = this.form.totalPrice - discount;
      this.form.cpm =
        this.form.finalPrice && this.form.impacts
          ? this.form.finalPrice / (this.form.impacts / 1000)
          : 0;
    },
    save() {
      this.processing = true;
      const Form = this.form;
      if (this.form.id) Form.createdOn = moment().format();
      else Form.updatedOn = moment().format();
      Form.id = this.form.id ? this.form.id : `pac${moment().format("X")}`;

      Form.status = Form.status ? "published" : "review";
      if (!Form.hasOwnProperty("hideAsus")) {
        Form.hideAsus = false;

        console.log("Form to save", Form);
      }
      Form.updatedOn = moment().format()
      Form.metrics = this.metrics
      Form.gamAdUnits = this.gamAdUnits.map(item => item.id)
      Form.gamCreativeTypes = this.gamCreativeTypes
      Form.gamCreativePlaceholders = this.gamCreativePlaceholders
      if(Form.computedAsus.coverage){
        Object.keys(Form.computedAsus.coverage).forEach(k => {
          if (k === "" || k === "null" || k === "undefined") {
            delete Form.computedAsus.coverage[k];
          }
        });
      
      }
      Form.coverage = Form.coverage.filter(v => v != null && v !== "");

      if(Form.impacts == NaN)
        Form.impacts = null

      console.log('SA V E', Form)
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      setDoc(doc(db, "packages", Form.id), Form).then(() => {
        this.processing = false;
        this.showSnack({
          text: this.$t("package.saved"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        // this.form = JSON.parse(JSON.stringify(this.snap))
        this.saved = true;
        this.$emit("reload-documents", true);
      });

    }
  },
};
</script>
